import React from "react";

import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import { toastMessage } from "utils/toastMessage";
import { deleteCategory } from "services/category";
import { deleteSelectedBrand } from "services/brand-management";

const DeleteBrand = ({
  deleteModal,
  selectedBrandDetail,
  setFetchedBrandData,
  closeModel,
}) => {
  console.log("selectedBrandDetail:---->", selectedBrandDetail);

  const [bannerButtonLoader, setBannerButtonLoader] = useButtonLoader("Yes");

  const deleteBannerHandler = async () => {
    try {
      setBannerButtonLoader(true);
      const {
        data: { code, status, message },
      } = await deleteSelectedBrand(selectedBrandDetail._id);
      if (status || code === 200) {
        // Remove the deleted category from the list
        setFetchedBrandData((prevList) =>
          prevList.filter(
            (bannerProp) => bannerProp._id !== selectedBrandDetail._id
          )
        );
        closeModel();
        toastMessage(message, "success", "DeleteCategory");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setBannerButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModal}
        handleClose={closeModel}
        content="Are you sure you want to Delete this Brand?"
        title="Delete Brand"
        buttonLoader={bannerButtonLoader}
        action={deleteBannerHandler}
      />
    </>
  );
};

export default DeleteBrand;
